/**
 * KuCoin WebSocket API
 * @see https://www.kucoin.com/docs-new/websocket-api/base-info/introduction
 */

import type { WsChannelDescriptor, WsTopologyInfo } from '../../lib/types';

export const KUCOIN_WS_PUBLIC_ENDPOINT = 'wss://ws-api.kucoin.com/endpoint';

/**
 * KuCoin Classic WebSocket Public Channels
 * @see https://www.kucoin.com/docs-new/websocket-api/base-info/get-public-token-spot-margin
 */
export const KUCOIN_WS_CHANNELS: Record<string, WsChannelDescriptor> = {
  level2: {
    channel: 'orderbook',
    topic: '/market/level2:<symbol>',
    supportsBatching: true,
    docUrl: 'https://www.kucoin.com/docs-new/3470068w0.md',
  },
  ticker: {
    channel: 'ticker',
    topic: '/market/ticker:<symbol>',
    supportsBatching: true,
    docUrl: 'https://www.kucoin.com/docs-new/3470063w0.md',
  },
  klines: {
    channel: 'klines',
    topic: '/market/candles:<symbol>_<interval>',
    supportsBatching: true,
    docUrl: 'https://www.kucoin.com/docs-new/3470071w0.md',
  },
  trades: {
    channel: 'trades',
    topic: '/market/match:<symbol>',
    supportsBatching: true,
    docUrl: 'https://www.kucoin.com/docs-new/3470072w0.md',
  },
};

/**
 * KuCoin WebSocket topology configuration
 * @see https://www.kucoin.com/docs-new/websocket-api/base-info/get-public-token-spot-margin
 */
export const KUCOIN_WS_TOPOLOGY: WsTopologyInfo = {
  baseUrl: KUCOIN_WS_PUBLIC_ENDPOINT,
  singleConnectionPerChannel: false,
  heartbeatIntervalMs: 25_000,
  note: 'Obtain a token via bullet-public before opening the WebSocket; send `{ "id": uuid, "type": "ping" }` heartbeats about every 25 seconds.',
};
